import { render, staticRenderFns } from "./partner-radio-group.vue?vue&type=template&id=3815b1b1"
import script from "./partner-radio-group.vue?vue&type=script&lang=js"
export * from "./partner-radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports